import { __awaiter } from "tslib";
import Animation from "../../Animation";
export default class FlashRam extends Animation {
    constructor(component) {
        super();
        this._name = "FlashRam";
        this.component = component;
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.component) {
                case "ADDRESS":
                    return ctx.ram.component.flashAddress(ctx.wires.model.addr_main.get().unsigned());
                case "DATA":
                    return ctx.ram.component.flashContent(ctx.wires.model.addr_main.get().unsigned());
            }
        });
    }
    toString() {
        return `${super.toString()}, component: ${this.component}`;
    }
}
